import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-model/views/views";
import * as z from "zod";

const BulkPickLineSchema_ = z.object({
  pickLineId: z.string(),
  workOrderId: z.string(),
  productId: z.string().nullable(),
  productSku: z.string().nullable(),
  productName: z.string().nullable(),
  productImageUrl: z.string().nullable(),
  productBarcodes: z.array(z.string()),
  quantityRequired: z.number(),
  quantityPicked: z.number(),
  sourceStorageLocationName: z.string().nullable(),
  status: z.string(),
  bomName: z.string().nullable(),
  externalOrderName: z.string().nullable(),
  toteName: z.string().nullable(),
  outputProductName: z.string().nullable(),
  outputProductImageUrl: z.string().nullable(),
  triggerKind: z.string(),
});
export const BulkPickLineSchema: z.ZodType<BulkPickLine> = BulkPickLineSchema_;
export interface BulkPickLine extends z.infer<typeof BulkPickLineSchema_> {}

export const getBulkPickLines = {
  name: "getBulkPickLines" as const,
  input: z.object({
    sessionId: z.string().optional(),
    stationId: z.string().optional(),
    sort: z
      .object({ key: z.string(), direction: z.enum(["asc", "desc"]) })
      .optional(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
  }),
  output: z.object({ lines: z.array(BulkPickLineSchema) }),
};
